import { NavigableButton } from '@carvana/ds-button';
import { ArrowUp } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useContext } from 'react';
import { SectionId } from '~/constants/vdp/section';
import NavigationStickyContext from '~/context/vdp/NavigationStickyContext';

export default function BackToTopButton() {
  const { isNavigationSticky } = useContext(NavigationStickyContext);

  return (
    <AnimatePresence>
      {isNavigationSticky && (
        <motion.div
          className="fixed bottom-2xl left-2xl z-10"
          initial={{ opacity: 0, x: -100 }}
          animate={{
            opacity: 1,
            x: 0,
            transition: {
              delay: 0.2,
              type: 'spring',
              duration: 0.5,
              bounce: 0.4
            }
          }}
          exit={{ opacity: 0, x: -100, transition: { duration: 0.3 } }}
        >
          <NavigableButton
            className="flex w-fit gap-md shadow-md"
            data-adobe-id={null}
            data-analytics-id="Back to Top"
            data-testid="back-to-top-button"
            href={`#${SectionId.Root}`}
            key="back-to-top-button"
            size="sm"
            variant="primaryInverted"
          >
            <ArrowUp size={16} />
            <span>Back to Top</span>
          </NavigableButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
